import { I18nSelector } from './components/I18nSelector';

export default I18nSelector;
